import React, { useContext } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import RacingDetailContext from '../../Context/RacingDetail.context';
import Button from 'src/components/Button/Button';

export default function MarketsStake() {
  const { selectedMarket, selectedSelectionType, setSelectedSelectionType } = useContext(RacingDetailContext);
  const { t } = useTranslation();
  const oddsType = ['boxed', 'singlePerm', 'floating'];
  const showWhen = [4, 6, 7];

  const onClick = (index) => (e) => {
    e.preventDefault();
    setSelectedSelectionType(oddsType[index]);
  };

  return (
    <div className="markets-container__stakes">
      {
        showWhen.includes(selectedMarket?.marketTypeId) &&
        _.map(oddsType, (type, index) => {
          return (<Button
            key={ index }
            className={
              classNames({
                'btn--outlined-dark markets-container__stake-btn':true,
                'markets-container__stake-btn--selected': type === selectedSelectionType
              })
            }
            size="big"
            onClick={ onClick(index) }
            text={ t(`racingDetail.${ type }`) }
          />);
        })
      }
    </div>
  );
}
